import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DynamicComponent } from './dynamic-component.component';

@NgModule({
    imports: [CommonModule],
    declarations: [DynamicComponent],
    entryComponents: [DynamicComponent],
    exports: [DynamicComponent]
})
export class DynamicComponentModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dynamic-component/dynamic-component.module.ts